import { render, staticRenderFns } from "./Proprietaire.vue?vue&type=template&id=3f918fc6&"
import script from "./Proprietaire.vue?vue&type=script&lang=ts&"
export * from "./Proprietaire.vue?vue&type=script&lang=ts&"
import style0 from "./Proprietaire.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports